import React from 'react';
import { useSelector } from 'react-redux';
import LoadingSpinner from './LoadingSpinner';

export default function LoadingOverlay() {
  const isLoading = useSelector((state: RootState) => state.loading.isLoading);

  if (!isLoading) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-30 z-50 flex items-center justify-center">
      <div className="bg-app-panel dark:bg-gray-800 rounded-lg p-4 flex items-center space-x-3">
        <LoadingSpinner size="medium" />
        <span className="text-gray-700 dark:text-gray-200">Loading...</span>
      </div>
    </div>
  );
} 